/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import HeaderContext from 'header_context';
import Hammer from 'hammerjs';
import ES6Promise from 'es6-promise';
import track from 'shared/segment';
import routes from 'handlebars_helpers/routes';

const {
  Promise
} = ES6Promise;

class Subnav {
  static initClass() {
    this.prototype.$toggle = $('.js--toggle-subnav');
    this.prototype.$close = $('.js--close-subnav');
    this.prototype.$referralsCta = $('.js--subnav-referrals-cta');
    this.prototype.$subnav = $('.js--subnav');
    this.prototype.$container = $('body');
    this.prototype.transitionDuration = 200;
    this.prototype.visibleClass = '-show-subnav';
  }

  constructor() {
    HeaderContext.register($.proxy(this.onHeaderContextChange, this));
    this.$toggle.on('click', $.proxy(this.toggleSubnav, this));
    this.$close.on('click', $.proxy(this.hide, this));
    this.$referralsCta.on('click', $.proxy(this.handleReferralsClick, this));
    delete Hammer.defaults.cssProps.userSelect;
    const hammer = new Hammer(document.body, {preventDefault: true});
    hammer.on('swipeleft', $.proxy(this.hide, this));
  }

  handleReferralsClick() {
    track('referrals.clicked_subnav_link');
    return window.location = routes('referrals_path');
  }

  toggleSubnav() {
    if (this.$container.is(`.${this.visibleClass}`)) { return this.hide(); } else { return this.show(); }
  }

  show() {
    this.$subnav.show();
    setTimeout(( () => this.$container.addClass(this.visibleClass)), 20);
    HeaderContext.switch(HeaderContext.SUBNAV);
    return this.setupClickOffListener();
  }

  // click-off-to-close
  setupClickOffListener() {
    return $(document).on('click.subnav', e => {
      if (!$(e.target).closest('.js--subnav-container, .js--search-container').length) {
        return this.hide();
      }
    });
  }

  hide(resolve) {
    if (this.$container.hasClass(this.visibleClass)) {
      this.$container.removeClass(this.visibleClass);
      setTimeout(() => {
        this.$subnav.hide();
        if (typeof resolve === "function") {
          return resolve();
        }
      }
      , this.transitionDuration);
      return $(document).off('click.subnav');
    } else if (typeof resolve === "function") {
      return resolve();
    }
  }

  onHeaderContextChange(newContext) {
    const promise = new Promise((resolve, reject) => {
      // we don't care about SEARCH context because in one column
      // layout search results appear within the subnav itself.
      if ((newContext === HeaderContext.NOTIFICATIONS) || (newContext === HeaderContext.MODAL)) { return this.hide(resolve); }
    });
    return promise;
  }
}
Subnav.initClass();

export default Subnav;
